export const COUPON_VOTE_UPSERT_REQUEST = "COUPON_VOTE_UPSERT_REQUEST";
export const COUPON_VOTE_UPSERT_SUCCESS = "COUPON_VOTE_UPSERT_SUCCESS";
export const COUPON_VOTE_UPSERT_FAILURE = "COUPON_VOTE_UPSERT_FAILURE";

export const COUPON_VOTE_REMOVE_REQUEST = "COUPON_VOTE_REMOVE_REQUEST";
export const COUPON_VOTE_REMOVE_SUCCESS = "COUPON_VOTE_REMOVE_SUCCESS";
export const COUPON_VOTE_REMOVE_FAILURE = "COUPON_VOTE_REMOVE_FAILURE";

export const COUPON_VOTE_CLEAR = "COUPON_VOTE_CLEAR";
